import script from "./teamTemplate.vue?vue&type=script&lang=ts&setup=true"
export * from "./teamTemplate.vue?vue&type=script&lang=ts&setup=true"

import "./teamTemplate.vue?vue&type=style&index=0&id=b60cd002&lang=less&scoped=true"
import "./teamTemplate.vue?vue&type=style&index=1&id=b60cd002&lang=less"

import exportComponent from "/opt/teams-app/node_modules/.pnpm/vue-loader@17.0.0_webpack@5.74.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b60cd002"]])

export default __exports__